module.exports = __webpack_public_path__ + "img/user-helmet-safety.31b644e7.svg";